import React from 'react'

export const NAME = 'MONITOR'

export const types = {
  MONITORS_LIST_REQUEST: `${NAME}/MONITORS_LIST_REQUEST`,
  MONITORS_LIST_SUCCESS: `${NAME}/MONITORS_LIST_SUCCESS`,
  MONITORS_LIST_FAILURE: `${NAME}/MONITORS_LIST_FAILURE`,
  MONITOR_CREATE_REQUEST: `${NAME}/MONITOR_CREATE_REQUEST`,
  MONITOR_CREATE_SUCCESS: `${NAME}/MONITOR_CREATE_SUCCESS`,
  MONITOR_CREATE_FAILURE: `${NAME}/MONITOR_CREATE_FAILURE`,
  MONITOR_EDIT_REQUEST: `${NAME}/MONITOR_EDIT_REQUEST`,
  MONITOR_EDIT_SUCCESS: `${NAME}/MONITOR_EDIT_SUCCESS`,
  MONITOR_EDIT_FAILURE: `${NAME}/MONITOR_EDIT_FAILURE`,
  EDIT_MONITOR_ACTION: `${NAME}/EDIT_MONITOR_ACTION`,
  MONITOR_DELETE_REQUEST: `${NAME}/MONITOR_DELETE_REQUEST`,
  MONITOR_DELETE_SUCCESS: `${NAME}/MONITOR_DELETE_SUCCESS`,
  MONITOR_DELETE_FAILURE: `${NAME}/MONITOR_DELETE_FAILURE`,
  WAREHOUSE_PRODUCTS_REQUEST: `${NAME}/WAREHOUSE_PRODUCTS_REQUEST`,
  WAREHOUSE_PRODUCTS_SUCCESS: `${NAME}/WAREHOUSE_PRODUCTS_SUCCESS`,
  WAREHOUSE_PRODUCTS_FAILURE: `${NAME}/WAREHOUSE_PRODUCTS_FAILURE`,
  WAREHOUSE_PRODUCTS_LIST_REQUEST: `${NAME}/WAREHOUSE_PRODUCTS_LIST_REQUEST`,
  WAREHOUSE_PRODUCTS_LIST_SUCCESS: `${NAME}/WAREHOUSE_PRODUCTS_LIST_SUCCESS`,
  WAREHOUSE_PRODUCTS_LIST_FAILURE: `${NAME}/WAREHOUSE_PRODUCTS_LIST_FAILURE`,
  PRODUCT_TYPE_LIST_REQUEST: `${NAME}/PRODUCT_TYPE_LIST_REQUEST`,
  PRODUCT_TYPE_LIST_SUCCESS: `${NAME}/PRODUCT_TYPE_LIST_SUCCESS`,
  PRODUCT_TYPE_LIST_FAILURE: `${NAME}/PRODUCT_TYPE_LIST_FAILURE`,
}

// Какие загрузки не удались (три запроса идут вместе, у каждого свой флаг).
const FAILED_FLAG = {
  MONITORS_LIST: 'monitors',
  WAREHOUSE_PRODUCTS_LIST: 'warehouseProducts',
  PRODUCT_TYPE_LIST: 'productTypes',
}
// 'MONITOR/MONITORS_LIST_FAILURE' -> { flag: 'monitors', stage: 'FAILURE' }
const LOAD_TYPE = new RegExp(`^${NAME}/(.+)_(REQUEST|SUCCESS|FAILURE)$`)
const loadStageOf = (type) => {
  const match = LOAD_TYPE.exec(type)
  return match && FAILED_FLAG[match[1]] ? { flag: FAILED_FLAG[match[1]], stage: match[2] } : null
}

export const initialState = {
  loadErrors: {},
  monitorsList: [],
  warehouseProductsList: [],
  productTypes: [],
  showEdit: false,
  tableColumns: [],
  products: []
}
export function reducer(state = initialState, action) {
  const load = loadStageOf(action.type)
  if (load) {
    // A load failed when the request failed, or when its answer could not be read (that comes
    // as a SUCCESS with `error` and no data).
    const failed = load.stage === 'FAILURE' || (load.stage === 'SUCCESS' && Boolean(action.error))
    const loadErrors = { ...state.loadErrors, [load.flag]: failed }
    if (failed || load.stage === 'REQUEST') return { ...state, loadErrors }
    state = { ...state, loadErrors }
  }
  switch (action.type) {
    case types.PRODUCT_TYPE_LIST_SUCCESS:
      return {
        ...state,
        productTypes: action.payload, // saving all the product types
      };
    case types.MONITORS_LIST_SUCCESS:
      const allProductTypes = (state.productTypes || []).map((product) => ({
        id: product.id,
        name: product.name,
      }));

      return {
        ...state,
        monitorsList: action.payload.map((monitor) => {
          const warehouseProducts = (state.warehouseProductsList || []).filter(
            (product) => product.warehouse_id === monitor.id
          );

          const productPrices = allProductTypes.reduce((acc, product) => {
            const foundProduct = warehouseProducts.find((wp) => wp.product_id === product.id);
            acc[`product_${product.id}`] = foundProduct ? `${foundProduct.product_price} грн` : "-";
            return acc;
          }, {});

          return {
            ...monitor,
            ...productPrices,
          };
        }),

        tableColumns: [
          {
            name: 'id',
            options: {
              display: 'executed',
              viewColumns: false,
              filter: false
            }
          },
          {
            label: 'Название склада',
            name: 'name',
          },
          ...allProductTypes
            .filter(product => product.id !== 5)
            .map((product) => ({
              label: product.name, // display product name
              name: `product_${product.id}`,
              options: {
                customBodyRender: (value) => value || "-",
                filter: false,
              },
            })),
          {
            label: 'Заметки',
            name: 'description',
          },
        ],
      };
    case types.WAREHOUSE_PRODUCTS_SUCCESS:
      return {
        ...state,
        selected: {
          ...state.selected,
          products: action.payload.products
        }
      };
    case types.WAREHOUSE_PRODUCTS_LIST_SUCCESS:
      return {
        ...state,
        warehouseProductsList: action.payload
      };
    case types.EDIT_MONITOR_ACTION: 
      return {
        ...state,
        showEdit: action.showEdit,
        selected: action.selected || {}
      }
    case types.MONITOR_EDIT_SUCCESS:
      return {
        ...state,
        showEdit: false
      }
    case types.MONITOR_DELETE_SUCCESS:
      return {
        ...state
      }
    default:
      return { ...state }
  }
}